module.exports = __webpack_public_path__ + "static/media/diving_1024.5ffb5fb3.jpg";